export type BienType =
  | "appartement"
  | "studio"
  | "chambre"
  | "boutique"
  | "bureau"
  | "magasin"
  | "local-commercial"
  | "autre";

export type BienStatut = "disponible" | "occupe" | "reserve" | "maintenance" | "indisponible";

export interface Bien {
  id: string;
  type: BienType;
  reference: string;
  immeubleId: string;
  etage: string;
  numero: string;
  surface: number;
  loyerMensuel: number;
  statut: BienStatut;
  description: string;
  infosComplementaires: string;
  createdAt: string;
}

export type BienInput = Omit<Bien, "id" | "createdAt">;

export const BIEN_TYPE_LABELS: Record<BienType, string> = {
  appartement: "Appartement",
  studio: "Studio",
  chambre: "Chambre",
  boutique: "Boutique",
  bureau: "Bureau",
  magasin: "Magasin",
  "local-commercial": "Local commercial",
  autre: "Autre",
};

export const BIEN_TYPE_ICONS: Record<BienType, string> = {
  appartement: "ri-home-4-line",
  studio: "ri-home-5-line",
  chambre: "ri-hotel-line",
  boutique: "ri-store-line",
  bureau: "ri-briefcase-line",
  magasin: "ri-store-2-line",
  "local-commercial": "ri-building-4-line",
  autre: "ri-home-4-line",
};

export const BIEN_TYPE_OPTIONS = (Object.keys(BIEN_TYPE_LABELS) as BienType[]).map((value) => ({
  value,
  label: BIEN_TYPE_LABELS[value],
}));

export const BIEN_STATUT_LABELS: Record<BienStatut, string> = {
  disponible: "Disponible",
  occupe: "Occupé",
  reserve: "Réservé",
  maintenance: "En maintenance",
  indisponible: "Indisponible",
};

export const BIEN_STATUT_TONES: Record<BienStatut, "primary" | "accent" | "secondary" | "neutral" | "danger"> = {
  disponible: "secondary",
  occupe: "primary",
  reserve: "accent",
  maintenance: "neutral",
  indisponible: "danger",
};

export const BIEN_STATUT_OPTIONS = (Object.keys(BIEN_STATUT_LABELS) as BienStatut[]).map((value) => ({
  value,
  label: BIEN_STATUT_LABELS[value],
}));

/**
 * Modèle de données prévu pour Supabase.
 * Table cible : `biens`
 *   id uuid primary key default gen_random_uuid()
 *   owner_id uuid references auth.users(id)
 *   immeuble_id uuid references immeubles(id) on delete cascade
 *   type text not null
 *   reference text
 *   etage text, numero text
 *   surface numeric, loyer_mensuel numeric
 *   statut text default 'disponible'
 *   description text, infos_complementaires text
 *   created_at timestamptz default now()
 * La liaison `immeuble_id` rattache chaque bien à un immeuble du module Immeubles.
 */